module.exports = "\n<app-alert-progress-bar *ngIf=\"alertProgressBar.show\" [data]=\"alertProgressBar.data\"></app-alert-progress-bar>"